import React from 'react'

import Fab from '@material-ui/core/Fab';

interface Props {
  uploadFiles: (e: React.SyntheticEvent<HTMLInputElement>) => void,
}

interface State {
}

class UploadButton extends React.Component<Props, State> {

  render() {
    return (  
      <div>
        <input
          id="uploader"
          style={{ display: 'none' }}
          type="file"
          accept="image/*"
          onChange={this.props.uploadFiles}
        />
        <Fab color="primary" variant="extended" size="large" id="file-upload">
          Upload an image
        </Fab>
      </div>
    );
  }

  }

  export default UploadButton;  
